import React, { Component } from 'react';
import {
  Container, Row, Col,
  Collapse,
  Jumbotron,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink } from 'reactstrap';
import CoolCarousel from './components/CoolCarousel';
import './App.css';
import lumber from './images/lumber-84678_1920.jpg';

class App extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div className="App">
        <Navbar color="dark" dark expand="md">
          <NavbarBrand href="/">Grind Pro Stump Removal</NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="About">About</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="Services">Services</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="#Portfolio">Portfolio</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="Contact">Contact</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
        <Container fluid>
          <Row>
            <Col xs="12">
              <Jumbotron fluid className="background" style={{background: `linear-gradient(rgba(20,20,20, .5), rgba(20,20,20, .5)), url(${lumber})`, height: 600, color: 'white', zIndex: -1}}>
                <Container fluid className="pt-md-5" style={{textAlign: 'center', maxWidth: 800}}>
                  <h1 className="display-1">Grind Pro Stump Removal</h1>
                  <p className="lead">Bacon ipsum dolor amet picanha spare ribs brisket meatball. Flank fatback tri-tip, andouille venison shank filet mignon buffalo cow salami ham beef ribs pork belly.</p>
                </Container>
              </Jumbotron>
            </Col>
          </Row>
          <Row id="Portfolio">
            <Col xs="12" md="10" lg="8" className="mx-auto">
              <CoolCarousel />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js